module.exports = __webpack_public_path__ + "img/1571438370.400074ca.jpg";